import { useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import Link from "@Components/Link";
import { bannerProps } from "@Components/contentful-components/banner/Banner";
import { DY_PAGE_CONTEXT } from "@Constants/common";
import { setDYContext } from "@Libs/dynamic-yield/dynamicYield";
import { useAppSelector } from "@wff/store/hooks";
import { localeSelector } from "@wff/store/localeSlice";
import HeroSlider from "../HeroSlider";
import classes from "./HomePageHeroSlider.module.scss";

export interface HomePageHeroSliderProps {
  banners: {
    items: bannerProps[];
  };
}

const HomePageHeroSlider = ({ banners }: HomePageHeroSliderProps) => {
  const { languageCode } = useAppSelector(localeSelector);
  //Set 'HOMEPAGE' DY-PageContext
  useEffect(
    () => setDYContext(DY_PAGE_CONTEXT.HOMEPAGE, languageCode),
    [languageCode]
  );

  const isMobile = useMediaQuery("(max-width:48em)");
  useEffect(() => {
    banners?.items?.map((item) => {
      const link = document.createElement("link");
      link.rel = "preload";
      link.href = isMobile
        ? `${item?.bannerImage?.url}?fm=webp&w=1024&h=768`
        : `${item?.bannerImage?.url}?fm=webp&w=1920&h=1080`;
      link.as = "image";
      document.head.appendChild(link);
    });
  }, [banners?.items, isMobile]);

  const [currentSlide, setCurrentSlide] = useState(0);
  const handleSlideChange = (index: number) => {
    setCurrentSlide(index);
  };
  const currentBanner = banners?.items?.[currentSlide];

  if (!currentBanner) {
    return null;
  }

  const content = () => {
    return (
      <>
        <h1 className={classes["home-page-hero-slide__content__title"]}>
          {currentBanner?.heading}
        </h1>
        <p>{currentBanner?.caption}</p>
        {currentBanner?.buttonText && currentBanner?.buttonLink && (
          <Link href={currentBanner?.buttonLink}>
            <a className="action">
              <span className={`${classes["section__cta"]}`}>
                {currentBanner?.buttonText}
              </span>
            </a>
          </Link>
        )}
      </>
    );
  };

  const CustomBanner = () => {
    const bannerImage = isMobile
      ? `${currentBanner?.bannerImage?.url}?fm=webp&w=1024&h=768`
      : `${currentBanner?.bannerImage?.url}?fm=webp&w=1920&h=1080`;
    return (
      <div
        className={`${classes["home-page-hero-slide"]} ${classes["section--slideshow"]} ${classes["slider__slide"]} ${classes["slider__slide--adjustable"]} ${classes["tns-item"]}`}
        style={{
          backgroundImage: `url("${bannerImage}")`,
        }}
      >
        <div className={classes["home-page-hero-slide__content"]}>
          {content()}
        </div>
      </div>
    );
  };

  return (
    <HeroSlider
      banners={banners}
      onSlideChange={handleSlideChange}
      customBanner={() => <CustomBanner />}
    />
  );
};

export default HomePageHeroSlider;
